// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='ExpandButtonWithText'] button {\n    font-weight: 600 !important;\n  }\n  [name='ExpandButtonWithText'] .ExpandButton {\n    margin-right: 7px;\n  }\n  [name='ExpandButtonWithText'] .ShowMoretextButton {\n    cursor: pointer;\n  }\n.reverse-exp-btn {\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse !important;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = exports;
